<template>
  <div v-if="isShow">
  <dialogWrap
    v-model="isShow"
    title="新增应收"
    @change="addChangeHandle"
    :width="'824px'"
  >
    <AddReceivableForm ref="addReceivable" />
    <template slot="footer">
      <el-button size="small" @click="cencelFn('receivable')">取消</el-button>
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        @click="submitAddCollecetion"
        v-submitDingTalkShow="18"
        >确认新增</el-button
      >
    </template>
  </dialogWrap>
</div>
</template>

<script>
import {
  addReceivable,
} from '@/api/financeApi'
import AddReceivableForm from '@/pages/finance/addReceivableForm/index.vue'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'

export default {
  components: {
    // AddReceivable,
    AddReceivableForm,
  },
  model: {
    prop: 'show',
    event: 'change',
  },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show(val) {
      this.isShow = val
      this.$nextTick(() => {
        this.addReceivableRef = this.$refs.addReceivable
      })
    },
    isShow(val) {
      this.$emit('change', val)
    },
  },
  data() {
    return {
      isShow: false,
      loading: false,
    }
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  methods: {
    // 添加事件关闭操作，清空验证
    addChangeHandle(bol) {
      if (!bol) {
        this.addReceivableRef.formResetFields()
      }
    },
    // 提交新建应收
    submitAddCollecetion() {
      this.$refs.addReceivable.formValidate().then(async (data) => {
        this.loading = true
        const { code } = await addReceivable(data)
        this.loading = false
        if (code === 1) {
          const msg = this.DingTalkShow18
            ? '提交审批成功'
            : '操作成功'
          this.$message.success(msg)
          this.addReceivableRef.formResetFields()
          this.isShow = false
          this.$emit('searchHandle')
        }
      }).catch(() => null)
    },
    cencelFn() {
      this.addReceivableRef.formResetFields()
      this.isShow = false
    },
  },
}
</script>

<style scoped lang="scss">
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
</style>
